<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="'Assinar Digitalmente'"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-confirmar="confirmar"
			:nome-botao-confirmar="nomeBotaoConfirmar"
			:acao-cancelar="cancelar"
			:is-confirmar-desabilitado="!formIsValid"
			@close="$emit('fechar-modal')"
		>
			<template #body>
				<v-row dense class="mt-3">
					<v-col cols="12" class="mb-2">
						<label-personalizado class="ma-0 py-0" nome-campo="Documento"></label-personalizado>
						<texto-tooltip
							:texto="tituloDocumento"
							:tamanho-maximo="tamanhoMaximoTituloDocumento"
						></texto-tooltip>
					</v-col>
					<v-col cols="12">
						<label-personalizado
							nome-campo="Certificado"
							:obrigatorioPorPadrao="true"
						></label-personalizado>
						<v-autocomplete
							v-model="certificadoThumbprint"
							:items="certificados"
							placeholder="Selecione um certificado digital"
							class="ma-0 py-0"
							name="Certificado"
							dense
							clearable
							item-text="prettyName"
							item-value="thumbprint"
							:rules="regrasCertificado"
						>
						</v-autocomplete>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import ValidacaoFormulario from '@/views/mixins/validacaoFormulario'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'modal-formulario-assinatura-digital-generico',
	components: { LabelPersonalizado, TextoTooltip },
	mixins: [ValidacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		nomeBotaoConfirmar: {
			type: String,
			required: true,
		},
		certificados: {
			type: Array,
			required: true,
		},
		tituloDocumento: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			tamanhoMaximoTituloDocumento: 500,
			regrasCertificado: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
			formIsValid: false,
			certificadoThumbprint: null,
		}
	},
	methods: {
		confirmar() {
			if (this.$refs.form.validate()) {
				this.$emit('assinar-digitalmente', this.certificadoThumbprint)
				this.$emit('fechar-modal-pai-avo')
			}
		},
		cancelar() {
			this.$emit('fechar-modal')
		},
	},
}
</script>
